<template>
  <v-autocomplete
    v-model="item"
    :label="label"
    :loading="loading"
    :items="items"
    :search-input.sync="search"
    clearable
    hide-no-data
    :hide-details="hideDetails"
    item-text="nazev_osoby"
    item-value="id"
    :filter="filter"
    return-object
    :disabled="disabled"
    :rules="rules"
  >
    <template
      slot="selection"
      slot-scope="{ item, selected }"
    >
      <span v-text="item.nazev_osoby"></span>
    </template>
    <template
      slot="item"
      slot-scope="{ item, tile }"
    >
      <v-list-tile-content>
        <v-list-tile-title>{{ item.nazev_osoby }}</v-list-tile-title>
      </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>
<script>
export default {
  data: function () {
    return {
      loading: false,
      items: [],
      search: "",
      counter: 0,
      timeout: null,
      item: null
    }
  },
  props: {
    hideDetails: Boolean,
    outline: Boolean,
    rules: {
      type: Array,
      default: []
    },
    value: Number,
    all: Boolean,
    disabled: Boolean,
    label: String
  },
  watch: {
    search (val) {
      val && val !== this.item && this.queryClients(val)
    },
    item (v) {
      this.$emit("changed", v);
      this.$emit("input", v == null ? null : v.id);
    }
  },
  mounted: function() {
    if (this.value != null)
      this.loadBasic();
  },
  methods: {
    filter: function(e) {
      return true;
    },
    queryClients: function(v) {
      this.counter++;
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.loading = true
        window.api.post("osoby/search", {
          s: v,
          echo: this.counter,
          klient: true
        }).then(function($r) {
          if ($r.echo != this.counter) return;
          this.items = $r.data;
          this.loading = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      }.bind(this), 300)
    },
    loadBasic: function() {
      window.api.get("osoby/"+this.value+"/basic").then((item) => {
        this.items.push(item);
        this.item = this.items[0];
      }).catch((err) => {
        console.log(err);
      });
    }
  },
  components: {

  }
}
</script>
<style scoped>
.v-select__selection-text {
  max-width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/ClientSearch.vue